import { Link, useSearchParams } from 'react-router-dom'
import { ArrowLeft, Building2, Clock, FolderKanban, Inbox, Package, Target } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Button } from '@/components/ui/Button'
import { PageToolbar, SegmentTabs } from '@/components/ui/page-toolbar'
import { ClienteAgradaDetailContent } from '@/components/ClientesAgrada/ClienteAgradaDetailContent'
import { ClienteAgradaDetailHeader } from '@/components/ClientesAgrada/ClienteAgradaDetailHeader'
import type { ClienteAgradaTabId } from '@/components/ClientesAgrada/clienteAgradaDetailTabsConfig'
import { useClienteAgradaDetailPage } from '@/hooks/useClienteAgradaDetailPage'

const TABS = [
  { id: 'cadastro' as const, label: 'Cadastro', icon: Building2 },
  { id: 'historico' as const, label: 'Histórico', icon: Clock },
  { id: 'servicos' as const, label: 'Serviços', icon: Package },
  { id: 'deals' as const, label: 'Deals', icon: Target },
  { id: 'projetos' as const, label: 'Projetos', icon: FolderKanban },
  { id: 'chamados' as const, label: 'Chamados', icon: Inbox },
]

export default function ClienteAgradaDetailPage() {
  const { tab, setTab, highlightProjectId, detail, loading, error, reload } =
    useClienteAgradaDetailPage()
  const [searchParams] = useSearchParams()
  const fromFinance = searchParams.get('from') === 'financeiro'
  const backTo = fromFinance ? '/financeiro?tab=projetos' : '/clientes'

  return (
    <DashboardLayout
      title='Clientes Agrada'
      actions={
        <Link to={backTo}>
          <Button variant='secondary' size='sm' type='button'>
            <ArrowLeft size={14} />
            Voltar
          </Button>
        </Link>
      }
    >
      <PageToolbar
        navigation={
          <SegmentTabs
            value={tab}
            onChange={(id) => setTab(id as ClienteAgradaTabId)}
            tabs={TABS}
            ariaLabel='Detalhes do cliente'
          />
        }
      />

      {error && (
        <div className='mb-4 rounded-lg border border-danger/30 bg-danger/5 px-4 py-3 text-sm text-danger'>
          {error}
        </div>
      )}

      {loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : detail ? (
        <>
          <ClienteAgradaDetailHeader detail={detail} />
          <ClienteAgradaDetailContent
            detail={detail}
            tab={tab}
            highlightProjectId={highlightProjectId}
            onProjectUpdated={() => void reload()}
          />
        </>
      ) : null}
    </DashboardLayout>
  )
}
